<template>
    <div class="top-title">
        <h2 class="online">{{ title }}</h2>
        <div class="title-msg">
            <span>{{ date }}</span>
            <span class="col-line">|</span>
            <span>{{ dept }}</span>
            <span class="col-line">|</span>
            <div class="icon">
                <img src="@/assets/com/eye.svg" />
                <span>{{ readyNum }}</span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { Spin } from 'ant-design-vue'
import { useRouter } from '@/hooks/useRouter'

const router = useRouter()

type Props = {
    /** 标题 */
    title?: string,
    date?: string,
    /** 作者 */
    dept?: string,
    readyNum?: string | number,
}

const props = withDefaults(defineProps<Props>(), {

})

</script>
<style lang="less" scoped>
.top-title {
    font-size: 18px;
}

.online {
    color: #006c6c;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    padding-bottom: 7px;
    margin: 0;
}

.col-line {
    margin: 0 6px;
}

.title-msg {
    border-bottom: 1px solid #e9dcd9;
    padding-bottom: 13px;
    margin-bottom: 29px;
    color: #a0a0a0;
    font-size: 12px;
    display: flex;
}


.icon {
    color: #ababab;
    font-size: 12px;
    display: flex;
    align-items: center;
    img {
        width: 16px;
        height: 16px;
        margin-right: 2px;
    }
}
</style>